/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import clsx from "clsx";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle as MuiDialogTitle,
  TextField,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  Typography,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  sendPendidikan,
  sendEditPendidikan,
  deletePendidikan,
} from "../../../../../store/actions";

import FieldIpk from "./FieldIpk";

const useStyles = makeStyles((theme) => ({
  field: {
    marginTop: theme.spacing(1),
  },
  cardActions: {
    justifyContent: "space-between",
  },
  btnDelete: {
    color: "#fff",
    background: theme.palette.red.color500,
    "&:hover": {
      backgroundColor: theme.palette.red.color700,
    },
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const validationSchema = yup.object().shape({
  educational_stage: yup.string().required("Wajib diisi"),
  name: yup.string().required("Wajib diisi"),
  major: yup.string().required("Wajib diisi"),
  in: yup.string().required("Wajib diisi"),
  out: yup.string().required("Wajib diisi"),
});

const DialogPendidikan = ({
  dialog,
  onClose,
  sendPendidikan,
  sendEditPendidikan,
  deletePendidikan,
  hcis,
}) => {
  const classes = useStyles();
  const params = useParams();

  const { register, errors, handleSubmit, control, setValue } = useForm({
    resolver: yupResolver(validationSchema),
    shouldUnregister: false,
  });

  const handleDelete = (id) => {
    if (hcis) {
      deletePendidikan(id, params.userId);
    } else {
      deletePendidikan(id);
    }
    onClose();
  };

  const onSubmit = (data, e) => {
    const formData = {
      ...data,
      gpa:
        data.gpa >= 100
          ? (data.gpa / 100).toFixed(2)
          : data.gpa >= 10
          ? (data.gpa / 10).toFixed(2)
          : (data.gpa * 100 / 100).toFixed(2),
    };
    if (dialog.edit) {
      if (hcis) {
        sendEditPendidikan(formData, dialog.value.id, params.userId);
      } else {
        sendEditPendidikan(formData, dialog.value.id);
      }
    } else {
      if (hcis) {
        sendPendidikan(formData, params.userId);
      } else {
        sendPendidikan(formData);
      }
    }
    e.target.reset();
    setValue("educational_stage", "");
    onClose();
  };

  useEffect(() => {
    if (dialog.edit) {
      setValue("educational_stage", dialog.value.educational_stage);
      setValue("name", dialog.value.name);
      setValue("major", dialog.value.major);
      setValue("in", dialog.value.in);
      setValue("out", dialog.value.out);
      setValue("gpa", dialog.value.gpa);
      return;
    }
    setValue("educational_stage", "");
    setValue("name", "");
    setValue("major", "");
    setValue("in", "");
    setValue("out", "");
    setValue("gpa", "");
  }, [dialog.edit]);

  return (
    <Dialog open={dialog.open} onClose={onClose} maxWidth="md" fullWidth>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle onClose={onClose}>
          {!dialog.edit ? "Tambah" : "Edit"} Riwayat Pendidikan
        </DialogTitle>
        <DialogContent dividers>
          <Controller
            control={control}
            name="educational_stage"
            defaultValue=""
            render={({ onChange, ref, value }) => (
              <TextField
                fullWidth
                select
                defaultValue=""
                label="Jenjang Pendidikan"
                inputRef={ref}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                error={!!errors.educational_stage}
                helperText={
                  !!errors.educational_stage && errors.educational_stage.message
                }
              >
                <MenuItem value="" disabled></MenuItem>
                <MenuItem value="SD">SD</MenuItem>
                <MenuItem value="SMP">SMP</MenuItem>
                <MenuItem value="SMA">SMA</MenuItem>
                <MenuItem value="S1">S1</MenuItem>
                <MenuItem value="S2">S2</MenuItem>
                <MenuItem value="S3">S3</MenuItem>
              </TextField>
            )}
          />
          <TextField
            className={classes.field}
            fullWidth
            name="name"
            label="Nama Perguruan Tinggi/Sekolah"
            inputRef={register}
            error={!!errors.name}
            helperText={!!errors.name && errors.name.message}
          />
          <TextField
            className={classes.field}
            fullWidth
            name="major"
            label="Jurusan/Prodi"
            inputRef={register}
            error={!!errors.major}
            helperText={!!errors.major && errors.major.message}
          />
          <TextField
            className={classes.field}
            fullWidth
            name="in"
            label="Tahun Masuk"
            inputRef={register}
            error={!!errors.in}
            helperText={!!errors.in && errors.in.message}
          />
          <TextField
            className={classes.field}
            fullWidth
            name="out"
            label="Tahun Lulus"
            inputRef={register}
            error={!!errors.out}
            helperText={!!errors.out && errors.out.message}
          />
          <Controller
            name="gpa"
            control={control}
            defaultValue=""
            render={({ onChange, value }) => (
              <FieldIpk
                className={classes.field}
                fullWidth
                label="IPK (hanya untuk D3, S1, S2, S3)"
                placeholder="4.00"
                onChange={onChange}
                value={value}
              />
            )}
          />
        </DialogContent>
        <DialogActions className={clsx({ [classes.cardActions]: dialog.edit })}>
          {dialog.edit && (
            <Button
              className={classes.btnDelete}
              variant="contained"
              onClick={() => handleDelete(dialog.value.id)}
            >
              Delete Data
            </Button>
          )}
          <Button variant="contained" color="primary" type="submit">
            {!dialog.edit ? "Simpan" : "Edit Data"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default connect(null, {
  sendPendidikan,
  sendEditPendidikan,
  deletePendidikan,
})(DialogPendidikan);
